export {}

const initFilterForm = () => {

  const filtrationForms = document.querySelectorAll(".f-filtration:not(.--inline)")

  filtrationForms.forEach((form) => {
    const openFilter = form.querySelector<HTMLButtonElement>(".--js-open-filter");
    const openFilterTitle = openFilter?.querySelector<HTMLElement>(".btn__title");
    const initTitle = openFilterTitle?.innerHTML ?? "";

    if (!openFilterTitle) return;

    openFilter?.addEventListener("click", () => {
      form.classList.toggle("--open")
      document.dispatchEvent(new Event("rangeReinit"))

      const title = openFilterTitle.innerHTML;
      const closeTitle = openFilter?.dataset.closeTitle ?? "";

      if (title == closeTitle) {
        openFilterTitle.innerHTML = initTitle
      } else {
        openFilterTitle.innerHTML = closeTitle
      }
    })
  })
}

initFilterForm()
document.addEventListener("filterReinit", initFilterForm)
